import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const GreenvaleEmergencyDentistPage = () => (
  <ServiceLocationTemplate suburbName="Greenvale" suburbSlug="greenvale" variant="emergency-dentist" />
);

export default GreenvaleEmergencyDentistPage;
